<template>
    <div>
        <WarehouseTable />
    </div>
</template>

<script>
import WarehouseTable from '@/components/warehouse/WarehouseTable.vue'
export default {
    components: {
        WarehouseTable
    },
    name: 'Warehousess'
}
</script>